import React from "react";
import ReactSlider from "react-slider";
import classnames from "classnames";

import doubleArrowsIcon from 'apps/QuoterApp/assets/images/Double arrows - Icon.svg';

import './styles.scss';

function Slider({className, values, showMarks, defaultValue, onChange, onAfterChange}) {
    const defaultValueIndex = values.indexOf(defaultValue);

    return <ReactSlider
        className={classnames("Slider", className)}
        thumbClassName={"Slider__Thumb"}
        trackClassName={"Slider__Track"}
        markClassName={"Slider__Mark"}
        marks={showMarks}
        max={values.length - 1}
        min={0}
        defaultValue={defaultValueIndex === -1 ? 0 : defaultValueIndex}
        renderThumb={(props, _) => <div  {...props}><img src={doubleArrowsIcon} alt={"<>"}/></div>}
        onChange={value => onChange && onChange(values[value])}
        onAfterChange={value => onAfterChange && onAfterChange(values[value])}
    />;
}

export default Slider;
